@if (!loading && !mfaEnabled && !mfaReminderSupressed) {
    <app-mfa-banner></app-mfa-banner>
}
<app-about-us class="card-wide"></app-about-us>
<app-inbox-list></app-inbox-list>
@if(ClientMatterContactDetails){
  @if (ClientMatterContactDetails.isMatterBased) {
    <app-matters-card></app-matters-card>
  }
  @else if(!ClientMatterContactDetails.isMatterBased){
    <app-activity-list></app-activity-list>
    <app-document-list></app-document-list>
  }
}
